import { all, put, fork, select, delay, takeLatest, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import toolsActions from '@iso/redux/tools/actions';
import { post } from '@iso/lib/helpers/resApiRequestor';

export function* logCurrentPage() {
  yield takeLatest('SET_CURRENT_PAGE', function* ({ payload }) {
    yield put({ type: actions.APPLY_CURRENT_PAGE, payload });

    try {
      yield delay(1000);

      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const customModules = state.Auth.customModules;
      const currentModule = customModules.find(module =>
        module.pages.find(page => page.id === payload.id)
      );

      const newReqBody = {
        module: {
          name: currentModule && currentModule.name,
          code: currentModule && currentModule.code,
          status: currentModule && currentModule.status
        },
        page: {
          name: payload && payload.name,
          code: payload && payload.code,
          status: payload && payload.status
        }
      };

      yield logCurrentPageAPI(newReqBody, roleHeaderAuth);

      if (
        currentModule.name.toUpperCase() === 'TOOLS' &&
        payload.name.toUpperCase() === 'SYSTEM LOGS'
      ) {
        yield put({
          type: toolsActions.FETCH_COSMOS_LOGS,
          data: null,
          payload: { page: 0, limit: 20 }
        });
      }
    } catch (error) {
      console.log(error);
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

export function* addSystemLogs() {
  yield takeEvery('ADD_SYSTEM_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_SYSTEM_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addSystemLogsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_SYSTEM_LOGS_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PAGE_ACTION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_SYSTEM_LOGS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_SYSTEM_LOGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

function logCurrentPageAPI(data, pagination, roleAuth) {
  return post(`log/current-page`, data, null, null, roleAuth);
}
function addSystemLogsAPI(data, roleAuth) {
  return post(`add/system-logs`, data, null, null, roleAuth);
}

export default function* rootSaga() {
  yield all([fork(logCurrentPage), fork(addSystemLogs)]);
}
